import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-proto";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { WebTracerProvider, BatchSpanProcessor } from "@opentelemetry/sdk-trace-web";
import { SpanFilteringExporter } from "~/openTelemetry/SpanFilteringExporter";
import { onlyWhenAuthenticatedFilter } from "~/openTelemetry/onlyWhenAuthenticatedFilter";
import { BrowserAttributesSpanProcessor } from "~/openTelemetry/processors/BrowserAttributesSpanProcessor";
import { PortalAttributesSpanProcessor } from "~/openTelemetry/processors/PortalAttributesSpanProcessor";
import { portalResource } from "~/openTelemetry/resources/portalResource";
import { resolveApplicationRootUri } from "~/utils/resolveApplicationRootUri";
const applicationRootUri = resolveApplicationRootUri(window.location);
const exporter = new OTLPTraceExporter({
    url: `${applicationRootUri}api/otlp/v1/traces`,
});
const provider = new WebTracerProvider({
    resource: portalResource,
    spanProcessors: [new BrowserAttributesSpanProcessor(), new PortalAttributesSpanProcessor(), new BatchSpanProcessor(new SpanFilteringExporter(exporter, [onlyWhenAuthenticatedFilter]))],
});
registerInstrumentations({
    instrumentations: [new XMLHttpRequestInstrumentation()],
});
provider.register();
